<template>
	<div class="video">
		<div class="video-content">
			<div class="monitor">
				<!-- <video :preload="preload" :poster="videoImg" :height="height" :width="width" align="center"
					:controls="controls" :autoplay="autoplay">
					<source :src="videoSrc" type="video/mp4">
				</video> -->
				<iframe src="http://47.96.7.199:10000/play.html?serial=34020000001320000001&code=34020000001320000001&aspect=fullscreen" width="100%" height="720" allowfullscreen allow="autoplay; fullscreen; microphone;"></iframe>
				<!-- <img src="../../assets/image/video1.jpeg" class="monitor_img"/> -->
			</div>
		</div>
		<div class="nav-center">

		</div>
		<div class="nav-video">
			<div class="nav-video-title">
				<p>视频控制</p>
			</div>
			<div class="nav-video-bottom">
				<!-- <div class="nav-video-1">
					<a-menu mode="inline" :open-keys="openKeys" @openChange="onOpenChange">
						<a-sub-menu key="sub1">
							<span slot="title"><span style="font-size: 16px;padding-left: 10px;">智慧园区</span></span>
							<a-menu-item id="nav1" key="1" style="font-size: 14px;">
								<a-icon type="play-circle" style="font-size: 16px;" />
								车辆视角
							</a-menu-item>
							<a-menu-item id="nav2" key="2" style="font-size: 14px;">
								<a-icon type="play-circle" style="font-size: 16px;" />
								监测视角
							</a-menu-item>
						</a-sub-menu>
					</a-menu>
				</div> -->
				<div class="nav-video-footer">
					<img src="../../assets/image/xian.png" style="width: 100%">
					<div class="video-direction">
						<div>
							<img src="../../assets/image/upleft.png" @click="control('upleft',500,1)"
								:class="{'active':isChoose==1}" />
							<img src="../../assets/image/up.png" @click="control('up',500,2)"
								:class="{'active':isChoose==2}" />
							<img src="../../assets/image/upright.png" @click="control('upright',500,3)"
								:class="{'active':isChoose==3}" />
						</div>
						<div>
							<img src="../../assets/image/left.png" @click="control('left',500,4)"
								:class="{'active':isChoose==4}" />
							<img src="../../assets/image/rotate.png" @click="control('left',3500,5)"
								:class="{'active':isChoose==5}" />
							<img src="../../assets/image/right.png" @click="control('right',500,6)"
								:class="{'active':isChoose==6}" />
						</div>
						<div>
							<img src="../../assets/image/downleft.png" @click="control('downleft',500,7)"
								:class="{'active':isChoose==7}" />
							<img src="../../assets/image/down.png" @click="control('down',500,8)"
								:class="{'active':isChoose==8}" />
							<img src="../../assets/image/downright.png" @click="control('downright',500,9)"
								:class="{'active':isChoose==9}" />
						</div>
					</div>
					<div class="video-focus">
						<img id="minus" src="../../assets/image/jian.png" @click="control('zoomout',500,10)"
							:class="{'active':isChoose==10}" />
						<!-- <a-slider id="test" :default-value="30" :disabled="disabled" /> -->
						<img id="plus" src="../../assets/image/jia.png" @click="control('zoomin',500,11)"
							:class="{'active':isChoose==11}" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				rootSubmenuKeys: ['sub1', ],
				openKeys: ['sub1'],
				url: 'http://47.96.7.199:10000',
				isChoose: false
			};
		},
		methods: {
			onOpenChange(openKeys) {
				const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
				if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
					this.openKeys = openKeys;
				} else {
					this.openKeys = latestOpenKey ? [latestOpenKey] : [];
				}
			},
			control(command, time, index) {
				this.isChoose = index
				axios({
					method: 'get',
					url: this.url + "/api/v1/control/ptz?serial=34020000001320000001&command=" + command +
						"&speed=180",
					header: {
						"Content-Type": "application/json"
					},
				}).then(res => {
					setTimeout(() => {
						axios({
							method: 'get',
							url: this.url +
								"/api/v1/control/ptz?serial=34020000001320000001&command=stop&speed=180",
							header: {
								"Content-Type": "application/json"
							},
						}).then(res => {
							this.isChoose = 0
						})
					}, time)
				})
			}
		},
	};
</script>

<style>
	.video {
		display: flex;
	}

	.video-content {
		width: 80%;
		margin-right: 2%;
		/* height: 629px; */
		background-color: #FFFFFF;
	}

	.video-content .monitor {
		padding: 30px;
	}

	.video-content .monitor .monitor_img {
		width: 100%;
		height: 660px;
	}

	.nav-center {
		width: 6px;
		background: #7F86E9;
		box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
	}

	.nav-video {
		width: 18%;
		background-color: #394177;
	}

	.nav-video-title {
		text-align: center;
		color: #FFFFFF;
		background-color: #272D55;
		line-height: 40px;
	}

	.nav-video-title p {
		margin-bottom: 0px;
		font-size: 14px;
	}

	.nav-video-bottom {
		height: 94%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding-top: 90%;
	}

	.nav-video-1 {
		padding: 0 15px;
	}

	.ant-menu-inline,
	.ant-menu-vertical,
	.ant-menu-vertical-left {
		border-right: 0px;
	}

	.ant-menu-submenu-vertical>.ant-menu-submenu-title .ant-menu-submenu-arrow,
	.ant-menu-submenu-vertical-left>.ant-menu-submenu-title .ant-menu-submenu-arrow,
	.ant-menu-submenu-vertical-right>.ant-menu-submenu-title .ant-menu-submenu-arrow,
	.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow {
		right: 0px;
		left: 15px;
		top: 19px;
	}

	.nav-video-1 .ant-menu {
		background-color: #394177;
		color: #FFFFFF;
		margin-top: 10px;
	}

	#nav1 {
		margin-top: 0px;
		margin-bottom: 0px;
	}

	#nav2 {
		margin-top: 0px;
		margin-bottom: 0px;
	}

	.ant-menu-item-selected {
		color: #FFFFFF;
	}

	.ant-menu-submenu-selected {
		color: #FFFFFF;
		background-color: rgba(127, 134, 233, 255, 0.16);
	}

	.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
		background-color: #394177;
	}

	.ant-menu-vertical .ant-menu-item::after,
	.ant-menu-vertical-left .ant-menu-item::after,
	.ant-menu-vertical-right .ant-menu-item::after,
	.ant-menu-inline .ant-menu-item::after {
		border-right: 0px;
	}

	.ant-menu-item:hover,
	.ant-menu-item-active,
	.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
	.ant-menu-submenu-active,
	.ant-menu-submenu-title:hover {
		color: #FFFFFF;
	}

	.ant-menu-submenu-vertical>.ant-menu-submenu-title .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-vertical-left>.ant-menu-submenu-title .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-vertical-right>.ant-menu-submenu-title .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-vertical>.ant-menu-submenu-title .ant-menu-submenu-arrow::after,
	.ant-menu-submenu-vertical-left>.ant-menu-submenu-title .ant-menu-submenu-arrow::after,
	.ant-menu-submenu-vertical-right>.ant-menu-submenu-title .ant-menu-submenu-arrow::after,
	.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow::after {
		background-image: none;
	}

	.ant-menu-submenu-vertical>.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
	.ant-menu-submenu-vertical-left>.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
	.ant-menu-submenu-vertical-right>.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
	.ant-menu-submenu-inline>.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
	.ant-menu-submenu-vertical>.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-vertical-left>.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-vertical-right>.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-inline>.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before {
		background: linear-gradient(to right, #FFFFFF, #FFFFFF)
	}

	.ant-menu-submenu-title {
		background-color: rgba(127, 134, 233, 0.16);
	}

	.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow::before {
		transform: rotate(40deg) translateX(3px);
	}

	.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow::after {
		transform: rotate(-40deg) translateX(-3px);
	}

	.ant-menu-submenu-open.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow::before {
		transform: rotate(40deg) translateX(-3px);
	}

	.ant-menu-submenu-open.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow::after {
		transform: rotate(-40deg) translateX(3px);
	}

	.nav-video-footer {
		/* border-top: 1px solid #7F86E9; */
		margin-top: 100px;
	}

	.video-direction {
		position: relative;
		background-image: url(../../assets/image/boxvie.png);
		background-size: 100% 100%;
		margin: 7%;
		border-radius: 5px;
	}

	.video-direction img {
		width: 33%;
		transform: scale(1);
		transition: all ease 0.5s;
	}

	.video-direction .active {
		transform: scale(0.9);
	}

	/* .video-direction::after {
		content: '';
		position: absolute;
		top: -19px;
		left: -18px;
		width: 252px;
		height: 1px;
		background-color: #000000;
	} */

	.video-focus {
		display: flex;
		width: 86%;
		margin: 0 auto;
		padding-bottom: 30px;
	}

	.video-focus #minus {
		width: 50%;
		padding-left: 10px;
		padding-right: 10px;
	}

	.video-focus #test {
		flex: 1;
		margin-top: 9px;
	}

	.video-focus #plus {
		width: 50%;
		padding-left: 9px;
		padding-right: 9px;
	}

	.ant-slider:hover .ant-slider-rail {
		background-color: #ABABAB;
	}

	.ant-slider:hover .ant-slider-track {
		background-color: #ABABAB;
	}

	.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
		border-color: #D4D4D4;
	}

	.ant-slider-rail {
		height: 7px;
		background-color: #ABABAB;
		box-shadow: 1px 1px 1px rgba(0, 0, 0, .29), 1px 1px 1px rgba(255, 255, 255, .44) inset;
		border-radius: 5px;
	}

	.ant-slider-handle {
		background: url(../../assets/image/huadong.png);
		border: 1px solid #D4D4D4;
		top: 5px;
	}

	.ant-slider-handle:focus {
		border-color: #D4D4D4;
		box-shadow: none;
	}

	.ant-slider-handle.ant-tooltip-open {
		border-color: #D4D4D4;
	}

	.ant-slider-track {
		background-color: #ABABAB;
	}
</style>
